import { filter, get } from "lodash";

export const selectSearch = (state) => get(state, ["search"], "");

export const searchEntities = (state, entityType, searchableAttributes) => {
  let entities = get(state, [entityType], []);
  if (["faqs", "notes", "documents", "maintenanceguide"].includes(entityType)) {
    var faqsNotesDocuments = get(state, ["faqsNotesDocuments"], []);
    //  if(entityType === 'notes') {
    entities = filter(
      faqsNotesDocuments,
      (fns) => fns?.type.toLowerCase() === entityType
    ).map((entity) => ({
      id: entity.id,
      documentType: entity.name,
      createdBy: entity.createdBy,
      itemName: entity.itemName,
      itemType: entity.itemType,
      faqType: entity.faqType,
      ...JSON.parse(entity.data),
      data: entity?.data,
      reminderDate: entity?.reminderDate,
      time: entity?.time,
      IsSuiteWarrantyStartDate: entity?.isSuiteWarrantyStartDate,
    }));
  }
  let search =
    get(state, ["search", "all"], "") !== ""
      ? get(state, ["search", "all"], "")
      : get(state, ["search", entityType], "");
  if (search !== "") {
    return filter(entities, (entity) =>
      isMatch(entity, searchableAttributes, search)
    );
  }
  return entities;
};

export const isMatch = (data, listOfAttributes, searchTerm) => {
  return listOfAttributes.some((attrName) => {
    var splitAttrs = attrName.split(".");
    var obj = data;
    var i;
    for (i = 0; i < splitAttrs.length; i++) {
      if (obj === null) {
        return false;
      }
      obj = obj[splitAttrs[i]];
    }

    if (obj === null || !obj) {
      return false;
    }
    return (
      obj.toString().toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1
    );
  });
};
